import React from 'react';

import { useForm } from 'react-hook-form';

const ChannelReports: React.FC = () => {
	return <></>;
};

export default ChannelReports;
